import {err} from 'framework';
import type {Result, UseCase, ValidationError} from 'framework';
import type {WorkoutError} from '../../domain/errors';
import type {WorkoutTemplate} from '../../domain/workout-template';
import type {
  CreateWorkoutTemplateInput,
  WorkoutRepository,
} from '../ports/workout.repository';
import type {CreateWorkoutTemplateDataValidator} from '../validators/create-workout-template-data.validator';

export class CreateWorkoutTemplate
  implements UseCase<[CreateWorkoutTemplateInput], WorkoutTemplate>
{
  constructor(
    private readonly repository: WorkoutRepository,
    private readonly validator: CreateWorkoutTemplateDataValidator,
  ) {}

  execute(
    input: CreateWorkoutTemplateInput,
  ): Promise<Result<WorkoutTemplate, WorkoutError | ValidationError>> {
    const validated = this.validator.validate(input);
    if (!validated.ok) {
      return Promise.resolve(err(validated.error));
    }
    return this.repository.createTemplate(validated.data);
  }
}
